module.exports = {"522624100":"八弓镇","522624101":"台烈镇","522624102":"瓦寨镇","522624103":"桐林镇","522624104":"雪洞镇","522624105":"长吉镇","522624106":"良上镇","522624200":"滚马乡","522624202":"款场乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522624.json
// module id = 2513
// module chunks = 0